import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { ensureVisitJwt } from './utils/auth';

const app = createApp(App);
app.use(router);
app.use(ElementPlus);

// 页面初始化时自动获取访问JWT，但只对需要认证的页面执行
// 检查当前路径是否需要认证
const currentPath = window.location.pathname;
const isPublicPath = currentPath === '/login' || currentPath.startsWith('/download');

if (!isPublicPath) {
  // 只有非公共页面才尝试获取JWT
  ensureVisitJwt();
}

app.mount('#app');